import { render, staticRenderFns } from "./VLeadWorkflows.vue?vue&type=template&id=2543e1d5&scoped=true"
import script from "./VLeadWorkflows.vue?vue&type=script&lang=js"
export * from "./VLeadWorkflows.vue?vue&type=script&lang=js"
import style0 from "./VLeadWorkflows.vue?vue&type=style&index=0&id=2543e1d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543e1d5",
  null
  
)

export default component.exports